import { IComponentOptions } from 'angular';
import { NotificationsCtrl } from './notifications.controller';

export const NotificationsComponent: IComponentOptions = {
  controller: NotificationsCtrl,
  bindings: {
    currentUser: '<',
    notifications: '<',
  },
  template: require('./notifications.html'),
};
